// extracted by mini-css-extract-plugin
export default {"hovereffect":"Project_hovereffect__LKtNH","overlay":"Project_overlay__tVYlV","project_name":"Project_project_name__xWPeW","project_languages":"Project_project_languages__jn5bq"};